// OnePlaceHQ Admin - Super admin dashboard and license management
// Version: 1.0.0
import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import naive from 'naive-ui'
import App from './App.vue'
import routes from './router'
import { toastPlugin } from '@shared/plugins/toastPlugin.js'
import '@shared/styles/intercom-toast.css'

const router = createRouter({
  history: createWebHistory(),
  routes,
})

// Navigation guard for auth
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('auth_token')

  if (to.meta.requiresAuth && !token) {
    next('/login')
  } else if (to.path === '/login' && token) {
    next('/')
  } else {
    next()
  }
})

const app = createApp(App)
app.use(router)
app.use(naive)
app.use(toastPlugin)
app.mount('#app')
